import Backbone from 'backbone';

export default Backbone.Model.extend({

	defaults: function() {
		return {
			defaultCurrency: 'CHF',
			foreignCurrency: 'CHF',
			rate: 1,
			reverseRate: 1
		};
	},

	/**
	 * Construct URL with 'foreignCurrency' parameter
	 **/
	url: function() {
		return '/extranet/currencyconversion?foreignCurrency=' + this.get('foreignCurrency');
	}
});
